import { createRouter, createWebHistory } from "vue-router";
import { useAuthStore } from "@/store/useAuth";
import homePage from "../views/homePage.vue";




const routes = [ 
  {
    path: "/",
    name:"home",
    component: homePage,
    meta: {
      title:  "پارسینه کالا | خرید آنلاین انواع محصولات و دسته‌بندی‌ها" ,
      metaTags: [
        {
          name: "description",
          content:
            " فروشگاه پارسینه کالا فروش اینترنتی انواع لباس کار ،کفش کار ،دستکش ، کلاه ایمنی در طرح های متنوع به صورت عمده و جزئی با کمترین قیمت و بالاترین کیفیت",
        },
      ],
    },
  },
  {
    path: "/payment",
    name: "payment",
    component: () => import(/* webpackChunkName: "payment" */ "@/views/payment/callBackPage.vue"),
    meta: {
      requireAuth: true,
      title: "نتایج خرید و وضعیت سفارش | پارسینه کالا" ,
      metaTags: [
        {
          name: "description",
          content: "نتیجه پرداخت",
        },
        {
          name:"robots",
          content:"noindex, nofollow"
        }
      ],
    },
  },
  {
    path: '/product', redirect: '/'  // Redirect /product to the home page
 },
  {
    path: "/product/:name",
    name: "product",
    component: () =>
      import(
        /* webpackChunkName: "product" */ "@/views/product/productPage.vue"
      ),
    meta: {
      dynamicTitle: true, // Indicate that the title is dynamic
      generateMetaDescription: (params) => {
        return `${params.name} `; // Generate dynamic description
      },
    },
  },

  {
    path: "/category/:name",
    name: "category",
    component: () =>
      import(/* webpackChunkName: "category" */ "@/views/category/categoryPage.vue"),
      meta: {
        title: "محصولات پارسینه کالا | مشاهده دسته‌بندی‌ها و خرید آنلاین",
        metaTags: [
          {
            name: "description",
            content: "فروشگاه پارسینه کالا فروش اینترنتی انواع لباس کار ،کفش کار ،دستکش ، کلاه ایمنی در طرح های متنوع به صورت عمده و جزئی با کمترین قیمت و بالاترین کیفیت",
          },

        ],
      },
  },
  {
    path: "/contactUs",
    name: "contactUs",
    component: () => import(/* webpackChunkName: "contactUs" */ "@/views/contactUs/contactUs.vue"),
    meta: {
      title: "تماس با پارسینه کالا | پشتیبانی و خدمات مشتریان" ,
      metaTags: [
        {
          name: "description",
          content: "صفحه تماس با ما جهت ارائه شماره تماس  های ما و ارائه آدرس جهت بازگشت محصولات و پاسخ به پرسش های مشتریان در فروشگاه پارسینه کالا طراحی شده است",
        },

      ],
    },
  },
  {
    path: "/steel",
    component: () => import(/* webpackChunkName: "steel" */ "@/views/steel/steelPage.vue"),
    meta: {
      title: "فروشگاه پارسینه کالا | فروش آنلاین محصولات استیل" ,
      metaTags: [
        {
          name: "description",
          content: "فروشگاه آنلاین پارسینه کالا - خرید آسان و با اطمینان انواع محصولات استیل با بهترین کیفیت و قیمت مناسب. ارسال سریع، استعلام قیمت به روز و خدمات برش حرفه‌ای. با ما، بهترین تجربه خرید را تجربه کنید.",
        },
      ],
    },
    children: [
      {
        path: "",
        name: "steel",
        component: () => import(/* webpackChunkName: "steel" */ "@/components/steelPageComponents/steelHome.vue"),
        meta: {
          title:  "استیل صنعت پارسا | خرید آنلاین انواع محصولات و دسته‌بندی‌ها" ,
      metaTags: [
        {
          name: "description",
          content:
            " فروشگاه استیل صنعت پارسا فروش انواع محصولات استیل شامل لوله استیل، ورق استیل، میلگرد و سایر محصولات استیل",
        },
      ],
        },
      },
      {
        path: "aboutUs",
        name: "steelAboutUs",
        component: () => import(/* webpackChunkName: "steel" */ "@/views/steel/aboutUs/aboutUs.vue"),
        meta: {
          title: "درباره استیل صنعت پارسا | اهداف و رسالت فروشگاه اینترنتی ما",
          metaTags: [
            {
              name: "description",
              content: " صفحه درباره ما با ارائه اطلاعات درباره هدف از ایجاد فروشگااستیل صنعت پارسا سعی در کسب اطمینان مشتریان و کارفرمایان شرکت ها می باشد.",
            },
            {
              name:"robots",
              content:"noindex, nofollow"
            }
          ],
        },
      },
      {
        path: "contactUs",
        name: "steelContactUs",
        component: () => import(/* webpackChunkName: "steel" */ "@/views/steel/contactUs/contactUs.vue"),
        meta: {
          title: "تماس بااستیل صنعت پارسا | شماره های تماس با فروشگاه اینترنتی ما",
          metaTags: [
            {
              name: "description",
              content: " صفحه تماس با ما با ارائه شماره تماس ها فروشگاه سعی در ایجاد ارتباط و پاسخ به سوالات خریداران می باشد . ",
            },
            {
              name:"robots",
              content:"noindex, nofollow"
            }
          ],
        },
      },
    ],
  },
  {
    path: "/terms",
    name: "terms",
    component: () => import( /* webpackChunkName: "terms" */  "@/views/terms/siteTerms.vue"),
    meta: {
      title: "قوانین و مقررات | شرایط خرید از فروشگاه پارسینه کالا",
      metaTags: [
        {
          name: "description",
          content: "بیان شرایط و مقررات جهت راهنمایی و پاسخ پرسش های مشتریان در باره شرایط خرید و مرجوعی محصول در فروشگاه اینترنتی پارسینه کالا.",
        },
      ],
    },
  },
  {
    path: "/work-with-us",
    name: "work-with",
    component: () => import(/* webpackChunkName: "work-with-us" */ "@/views/work-with-us/workWithUs.vue"),
    meta: {
      title: "همکاری با ما | فرصت‌های همکاری در پارسینه کالا"
,
      metaTags: [
        {
          name: "description",
          content: " همکاری با ما جهت همکاری با سایر تولید کنندگاه و در صورت تمایل و فروش محصولات تولیدکنندگان از وب سایت فروشگاه اینترنتی پارسینه کالا",
        },
      ],
    },
  },
  {
    path: "/aboutUs",
    name: "aboutUs",
    component: () => import( /* webpackChunkName: "about" */ "@/views/aboutUs/aboutUs.vue"),
    meta: {
      title: "درباره پارسینه کالا | اهداف و رسالت فروشگاه اینترنتی ما",
      metaTags: [
        {
          name: "description",
          content: " صفحه درباره ما با ارائه اطلاعات درباره هدف از ایجاد فروشگاه پارسینه کالا سعی در کسب اطمینان مشتریان و کارفرمایان شرکت ها می باشد.",
        },
      ],
    },
  },
  {
    path: "/search",
    name: "search",
    component: () => import(/* webpackChunkName: "search" */ "@/views/search/searchComponent.vue"),
    meta: {
      title:  "جستجوی سریع محصولات | بهترین نتایج در پارسینه کالا",
      metaTags: [
        {
          name: "description",
          content:" فروشگاه پارسینه کالا فروش اینترنتی انواع لباس کار ،کفش کار ،دستکش ، کلاه ایمنی در طرح های متنوع به صورت عمده و جزئی با کمترین قیمت و بالاترین کیفیت",
        },

      ],
    },
  },
  {
    path: "/cart",
    name: "cart",
    component: () => import(/* webpackChunkName: "cart" */"@/views/cart/cartBody.vue"),
    meta: {
      title: "سبد خرید شما | مشاهده، ویرایش و تکمیل خرید در پارسینه کالا",
      metaTags: [
        {
          name: "description",
          content:" فروشگاه پارسینه کالا فروش اینترنتی انواع لباس کار ،کفش کار ،دستکش ، کلاه ایمنی در طرح های متنوع به صورت عمده و جزئی با کمترین قیمت و بالاترین کیفیت",
        },
        {
          name:"robots",
          content:"noindex, nofollow"
        }
      ],
    },
  },
  {
    path: "/product-tag/:name",
    name: "tag",
    component: () => import(/* webpackChunkName: "product-tag" */"@/views/search/searchComponent.vue"),
    meta: {
      dynamicTitle: true, // Indicate that the title is dynamic
      generateMetaDescription: (params) => {
        return `${params.name}`; // Generate dynamic description
      },
      
    },
  },
  {
    path: "/checkout",
    name: "checkout",
    component: () => import(/* webpackChunkName: "checkout" */ "@/views/checkOut/checkOut.vue"),
    meta: {
      requireAuth: true,
      title: "تکمیل خرید و پرداخت امن | فروشگاه اینترنتی پارسینه کالا",
      metaTags: [
        {
          name: "description",
          content:" فروشگاه پارسینه کالا فروش اینترنتی انواع لباس کار ،کفش کار ،دستکش ، کلاه ایمنی در طرح های متنوع به صورت عمده و جزئی با کمترین قیمت و بالاترین کیفیت",
        },
        {
          name:"robots",
          content:"noindex, nofollow"
        }
      ],
    },
  },
  {
    path: "/user/login",
    name: "user-login",
    component: () => import("@/views/user/login/userLogin.vue"),
    meta: {
      title: "ثبت نام و ورود | پنل کاربری در فروشگاه اینترنتی پارسینه کالا",
      metaTags: [
        {
          name: "description",
          content: " صفحه ورود کاربر به پروفایل کاربری جهت مشاهده پروفایل کاربری، پیگیری سفارشات، ثبت نظرات در مورد محصولات و تکمیل خربد در فروشگاه اینترنتی پارسینه کالا",
        },
        {
          name:"robots",
          content:"noindex, nofollow"
        }
      ],
    },
  },
  {
    path: "/profile",
    name: "profile",
    component: () => import(/* webpackChunkName: "profile" */ "@/views/profile/profilePage.vue"),
    meta: {
      requireAuth: true,
      title: "فروشگاه پارسینه کالا",
      metaTags: [
        {
          name:"robots",
          content:"noindex, nofollow"
        }
      ],
    },
    children:[
      {
        path: "",
        name: "user-profile",
        component: () =>
          import(/* webpackChunkName: "user-profile" */ "@/views/profile/edit/editProfile.vue"),
        meta: {
          // requireAuth: true,
          title: "پارسینه کالا- پروفایل کاربر  ",
          metaTags: [
            {
              name: "description",
              content: "",
            },
            {
              name:"robots",
              content:"noindex, nofollow"
            }
          ],
        },
      },
      {
            path: "order",
            name: "user-order",
            component: () =>
              import(/* webpackChunkName: "user-order" */ "@/views/profile/orders/ordersPage.vue"),
            meta: {
            requireAuth: true,

              title: "پارسینه کالا-سفارشات  ",
              metaTags: [
                {
                  name: "description",
                  content: "",
                },
                {
                  name:"robots",
                  content:"noindex, nofollow"
                }
              ],
            },
          },
          {
              path: "order/:id",
              name: "order-details",
              component: () =>
              import(/* webpackChunkName: "user-order" */ "@/views/profile/orders/orderDetails.vue"),
              meta: {
             requireAuth: true,

              title: "پارسینه کالا-سفارشات  ",
              metaTags: [
                {
                  name: "description",
                  content: "",
                },
                {
                  name:"robots",
                  content:"noindex, nofollow"
                }
              ],
              },
          },
          {
                path: "favorite",
                name: "user-favorite",
                component: () =>
                  import(/* webpackChunkName: "favorite" */ "@/views/profile/favorite/favoriteComponent.vue"),
                meta: {
                  title: "پارسینه کالا-علاقه مندی ها",
                  metaTags: [
                    {
                      name: "description",
                      content: "",
                      
                    },
                  ],
                },
              },
    ]
  
  },
  {
    path:"/profile/order/invoice/:id",
    name:"profile-print",
    component:()=>import("@/components/profileComponent/printFactor.vue"),
    meta: {
      title: "مشاهده و چاپ فاکتور خرید | فروشگاه پارسینه کالا",
      metaTags: [
        {
          name:"robots",
          content:"noindex, nofollow"
        }
      ],
    },
  },
  {
    path: "/:pathMatch(.*)*",
    name: "not-found",
    component: () => import("@/views/nouFound/notFound.vue"),
    meta: {
      title: "خطا 404 | صفحه مورد نظر یافت نشد | فروشگاه پارسینه کالا",
      metaTags: [
        {
          name: "description",
          content: " فروشگاه پارسینه کالا فروش اینترنتی انواع لباس کار ،کفش کار ،دستکش ، کلاه ایمنی در طرح های متنوع به صورت عمده و جزئی با کمترین قیمت و بالاترین کیفیت",
        },
      ],
    },
  },
  {
    path:'/namad',
    name: "namad",
    component: () => import( /* webpackChunkName: "terms" */  "@/views/enemad/namadPage.vue"),
    meta: {
      title: "نمادهای اعتماد فروشگاه پارسینه کالا | بررسی اعتبار و مجوزها",
      metaTags: [
        {
          name: "description",
          content: "صفحه مشاهده نماد های سایت اینترنتی پارسینه کال جهت اطلاع از تاریخ دریافت نماد و اطمینان مشتری از یک خرید خوب و ایمن."
        }
      ],
    },
  },

];

const Router = createRouter({
  routes,
  history: createWebHistory(process.env.BASE_URL),
  // history: createWebHistory('/test/'),

  // scrollBehavior use until when open page scroll to top 
  scrollBehavior(to, from, savedPosition) {
    // Always scroll to top when navigating to a new page
    return { top: 0, behavior: 'smooth' };
  }
});


Router.beforeEach((to, from, next) => {
  const useAuth = useAuthStore();
  document.title = to.meta.title;

   // Remove existing meta description tags
   const existingMetaTags = document.querySelectorAll('meta[name="description"]');
   existingMetaTags.forEach((tag) => {
     tag.remove();
   });

   if (to.meta.dynamicTitle) {
    document.title =
      to.name === "product"
        ? ` مشخصات، قیمت و خرید ${to.params.name.replace(/-/g, " ")}`
        : to.name === "tag"
        ? ` نتایج جستجو برای برچسب ${to.params.name.replace(/-/g, " ")}`
        : `${to.params.name} - فروشگاه پارسینه کالا`;
  } else {
    document.title = to.meta.title || "Default Title";
  }

  if (to.meta.generateMetaDescription) {
    const generatedDescription = to.meta.generateMetaDescription(to.params);
    const existingMetaTag = document.querySelector('meta[name="description"]');

    if (existingMetaTag) {
      existingMetaTag.setAttribute("content", generatedDescription);
    } else {
      const metaTag = document.createElement("meta");
      metaTag.setAttribute("name", "description");
      metaTag.setAttribute("content", generatedDescription);
      document.head.appendChild(metaTag);
    }
  }

  const metaTags = to.meta.metaTags;

  if (metaTags) {
    metaTags.forEach((tag) => {
      const metaTag = document.createElement("meta");
      metaTag.setAttribute("name", tag.name);
      metaTag.setAttribute("content", tag.content);
      document.head.appendChild(metaTag);
    });
  }
  if (to.meta.requireAuth && !useAuth.getAuth) {
    next({ name: "user-login" });
  } else {
    next();
  }
});
export default Router;
